// Liste des professions
export const PROFESSIONS = [
    "Élève",
    "Étudiant",
    "Enseignant",
    "Ingénieur",
    "Médecin",
    "Infirmier(ère)",
    "Commerçant(e)",
    "Entrepreneur",
    "Comptable",
    "Banquier",
    "Fonctionnaire",
    "Agent de sécurité",
    "Militaire",
    "Avocat",
    "Agriculteur",
    "Artisan",
    "Informaticien",
    "Marketing/Communication",
    "Artiste",
    "Couturier(ère)",
    "Chef d'entreprise",
    "Sans emploi",
    "Retraité",
    "Autre"
];


/**
 * Encode une adresse email pour une utilisation sécurisée comme clé dans Firebase RTDB
 * Remplace les caractères invalides dans les chemins Firebase (., #, $, [, ])
 *
 * @param {string} email - L'adresse email à encoder
 * @returns {string} - L'adresse email encodée
 */
export const encodeEmail = (email) => {
    if (!email) return '';
    return email.replace(/\./g, ',')
        .replace(/#/g, '-hash-')
        .replace(/\$/g, '-dollar-')
        .replace(/\[/g, '-lbracket-')
        .replace(/]/g, '-rbracket-');
};

/**
 * Décode une adresse email encodée pour restaurer sa forme originale
 *
 * @param {string} encodedEmail - L'adresse email encodée
 * @returns {string} - L'adresse email originale
 */
export const decodeEmail = (encodedEmail) => {
    if (!encodedEmail) return '';
    return encodedEmail.replace(/,/g, '.')
        .replace(/-hash-/g, '#')
        .replace(/-dollar-/g, '$')
        .replace(/-lbracket-/g, '[')
        .replace(/-rbracket-/g, ']');
};
